/*jshint esversion:6*/
import React from "react";
import Breadcrumbs from "react-breadcrumbs";
import Toaster from "toastr";
import { connect } from "react-redux";
import { Permissioned } from "react-permissions";
import PageTitle from "../common/pageTitle";
import Util from "../../util/util";
import Messages from "../../configurations/messages";
import Constants from "../../configurations/constants";
import Permissions from "../../configurations/permissions";
import ReportsApi from "../../api/ReportsApi";
import ReportsTable from "./ReportsTable";
import ReportsSearch from "./ReportsSearch";

class ReportsPage extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      reports: [],
      reportType: null,
      selectedReport: null,
      totalCount: 0,
      loading: false,
      pages: 0,
      openModalFlag: false,
      pageSize: Constants.DEFAULT_TABLE_PAGE_SIZE,
      filterParams: null,
      pageNum: 0 //Zero based index
    };
    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.onSearchHandler = this.onSearchHandler.bind(this);
    this.onTableChange = this.onTableChange.bind(this);
    this.onRowClick = this.onRowClick.bind(this);
    this.paginateid = this.paginateid.bind(this);
    this.onDownloadClick = this.onDownloadClick.bind(this);
    this.onRetryClick = this.onRetryClick.bind(this);
  }

  onSearchHandler(data) {
    const { reportType, ...filterParams } = data;
    this.setState(
      { reportType: data.reportType, pageNum: 0, filterParams },
      () => this.reloadReports(this.state.filterParams)
    );
  }

  paginateid(index) {
    const offset = parseInt(this.state.pageNum, 0);
    const pagesize = parseInt(this.state.pageSize, 0);
    const result =
      offset * pagesize + index + Constants.PAGINATION_OFFSET_INDEX;
    return result.toString();
  }

  render() {
    return (
      <div>
        <div id="page-breadcrumb" className="breadcrumb-container">
          <Breadcrumbs
            separator={Constants.BREADCRUMB_SEPARATOR}
            routes={this.props.routes}
            params={this.props.params}
          />
        </div>
        <PageTitle title="Reports" />
        <ReportsSearch onSearchHandler={this.onSearchHandler} />
        <ReportsTable
          onRowClick={this.onRowClick}
          reportType={this.state.reportType}
          loading={this.state.loading}
          onTableChange={this.onTableChange}
          page={this.state.pageNum}
          pages={this.state.pages}
          defaultPageSize={Constants.DEFAULT_TABLE_PAGE_SIZE}
          reports={this.state.reports}
          paginatedCallback={this.paginateid}
          retryReportGeneration={this.onRetryClick}
          reloadReports={this.reloadReports}
          downloadReports={this.onDownloadClick}
        />
      </div>
    );
  }

  onTableChange(state, instance) {
    let pageSize = instance.state.pageSize;
    let pageNum = instance.state.page; //table page  - Zero based index
    this.setState({ pageSize: pageSize, pageNum: pageNum });
    if (this.state.filterParams) {
      let params = Util.clone(this.state.filterParams);
      params.pageSize = pageSize;
      params.pageNum = pageNum + 1;

      this.loadReports(params);
    }
  }

  loadReports(params, resetPageNumber) {
    //Reset states
    let stateUpdate = { loading: true };
    if (resetPageNumber) {
      stateUpdate.pageNum = 0;
      params.pageNum = 1;
    }
    this.setState(stateUpdate);
    params.pageSize = params.pageSize || this.state.pageSize;
    params.pageNum = params.pageNum || this.state.pageNum + 1;
    params.reportType = params.reportType || this.state.reportType
    ReportsApi.getReports(params)
      .then(response => {
        let data = response.data.content;
        let totalCount = response.data.count;
        let pages = totalCount
          ? Math.ceil(
              totalCount /
                (params.pageSize || Constants.DEFAULT_TABLE_PAGE_SIZE)
            )
          : 0;
        if (data.length === 0) Toaster.warning("No records found.");
        this.setState({
          reports: data,
          loading: false,
          filterParams: params,
          totalCount: totalCount,
          pages: pages
        });
      })
      .catch(error => {
        console.log(error);
        Util.errorMessageToast(Toaster, error.data, [
          ` ${Messages.ERROR_REPORTS}`
        ]);
        this.setState({ loading: false });
      });
  }

  onRowClick(index) {
    this.setState({
      selectedReport: this.state.reports[index],
      openModalFlag: true,
      createFlag: false
    });
  }

  onRetryClick(id) {
    ReportsApi.retryReportGeneration(this.state.reportType, id)
      .then(response => {
        this.reloadReports(this.state.filterParams);
        Toaster.success("Report generation resent");
      })
      .catch(error => {
        Util.errorMessageToast(Toaster, error.data, [` ${error.description}`]);
      });
  }

  onDownloadClick(filename) {
    ReportsApi.downloadReport(filename)
      .then(response => {
          window.open(response.request.responseURL, "_blank");
      })
      .catch(error => {
        Util.errorMessageToast(Toaster, error.data, [` ${error.description}`]);
      });
  }

  handleCloseModal(event, reloadDataFlag) {
    this.setState({
      selectedReport: null,
      openModalFlag: false,
      createFlag: false
    });
    if (reloadDataFlag) {
      this.reloadReports(this.state.filterParams);
    }
  }

  reloadReports(params) {
    this.setState({ reports: [] });
    this.loadReports({ ...params, pageSize: this.state.pageSize });
  }
}

export default connect(Util.defaultMapStateToProps)(
  Permissioned(ReportsPage, [Permissions.VIEW_SETTLEMENT_REPORT])
);



// WEBPACK FOOTER //
// ./src/components/reports/ReportsPage.js